import React from "react"
import clsx from "clsx"
import { useTranslation } from "react-i18next"

import classes from "./TdFormShapes.module.scss"

const shapes = ["square", "circle", "diamond"]
const shapesInFarsi = ["مربع", "دایره", "لوزی"]

const TdFormShapes = props => {
  const { setForm, form } = props

  const [t, i18n] = useTranslation()

  const handleChange = (value, name) => {
    setForm(prev => ({
      ...prev, [name]: value
    }))
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["item"]}>
      <div className={classes["title"]}>
        {t("شکل_میز")}
      </div>

      <div className={classes["shapes"]}>
        {shapes.map((shape, sIndex) =>
          <button
            key={shape}
            onClick={() => handleChange(shape, "shape")}
            className={clsx(
              classes[shape],
              isLtr && classes[`${shape}-ltr`],
              form.shape === shape && classes["active"]
            )}
          >
            <span>
              {t(shapesInFarsi[sIndex])}
            </span>
          </button>
        )}
      </div>
    </div>
  )
}

export default TdFormShapes